import React from 'react';
import { Helmet } from 'react-helmet';

interface MetaTagsProps {
  title: string;
  description: string;
  image?: string;
  url?: string;
  type?: string;
  keywords?: string;
  author?: string;
  noindex?: boolean;
  canonical?: string;
}

export const MetaTags: React.FC<MetaTagsProps> = ({
  title,
  description,
  image = '/metatag_moafriends.jpg',
  url,
  type = 'website',
  keywords,
  author = '모아프렌즈',
  noindex = false,
  canonical
}) => {
  const siteName = '모아프렌즈';
  const fullTitle = title === siteName ? title : `${title} | ${siteName}`;
  const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const imageUrl = image.startsWith('http') ? image : `${process.env.REACT_APP_BASE_URL || ''}${image}`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph Tags for Facebook, KakaoTalk, etc */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="ko_KR" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:site" content="@moafriends" />
      
      {/* Additional Tags for Better SEO */}
      <meta property="article:author" content={author} />
      <meta name="theme-color" content="#FF6B6B" />
      
      {/* Kakao Specific Tags - Important for Korean Market */}
      <meta property="kakao:title" content={fullTitle} />
      <meta property="kakao:description" content={description} />
      <meta property="kakao:image" content={imageUrl} />
    </Helmet>
  );
};